import http from '@/apis/utils/request-plugin';
/// utils/request-plugin

const baseUrl = '';

/**
 * 获取全局参数（未登录状态下获取）
 *
 * @param data 数据对象
 * @returns 返回Promise对象，用于处理异步请求结果
 */
const getGlobalParamForUnLogged = () =>
  http.get(`${baseUrl}/get-global-param`, undefined, {
    tokenType: 'none',
  });

/**
 * 获取全局参数(已登录状态下获取)
 *
 * @param data 数据对象
 * @returns 返回Promise对象，用于处理异步请求结果
 */
const getGlobalParamForLogged = () =>
  http.get(`${baseUrl}/common/get-global-param`);

/**
 * 获取系统区域列表
 *
 * @param data 请求参数
 * @returns http.get 请求结果
 */
const getSysRegionList = (data: { maxRegionLevel?: number }) =>
  http.get(`${baseUrl}/get-sys-region-list`, data, {
    tokenType: 'none',
  });

/**
 * 获取系统区域列表
 *
 * @param data 请求参数
 * @returns http.get 请求结果
 */
export const getSysRegionSearchList = (data: {
  /**
   * 父级地区代码
   */
  parentRegionCode?: string;
  /**
   * 地区级别
   */
  regionLevel?: number;
  /**
   * 地区名称
   */
  regionName?: string;
}) => http.get(`${baseUrl}/get-sys-region-list-for-search`, data);

/**
 * 根据数据字典分类代码列表获取数据字典
 */
export const getDataDicByTypeCodeList = (data: {
  /**
   * 数据字典分类代码列表
   */
  dataDicTypeCodeList: string[];
}) => http.postJson(`${baseUrl}/common/get-data-dic-by-type-code-list`, data);

/**
 * 心跳：刷新当前用户在线状态（后端写入 sa:login:online-user:{userId}:{appId}）
 * silent: true 表示彻底静默，失败时跳过全局错误提示与 401 弹窗，仅由本地 catch 吞掉
 */
const heartbeat = () =>
  http.postJson(`${baseUrl}/common/heartbeat`, undefined, { silent: true });

export {
  getGlobalParamForUnLogged,
  getSysRegionList,
  getGlobalParamForLogged,
  heartbeat,
};
